import CryptoJS from "crypto-js";

const SECRET_KEY_LOCAL_STORAGE = process.env.REACT_APP_SECRET_KEY;

if (!SECRET_KEY_LOCAL_STORAGE) {
  throw new Error("Secret key not defined. Please check your .env file.");
}

export const encryptData = (data) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SECRET_KEY_LOCAL_STORAGE
    ).toString();
    return encrypted;
  } catch (error) {
    console.error("Kesalahan enkripsi:", error);
    return null;
  }
};

export const decryptData = (cipherText) => {
  if (!cipherText) {
    return null;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY_LOCAL_STORAGE);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedData) {
      throw new Error("Data yang didekripsi tidak valid");
    }
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("Kesalahan dekripsi:", error);
    return null;
  }
};
